import { registerCrmActionBlot } from "./crmActionBlot";

let chatQuillBlotsRegistered = false;

/** Registers Ask Type+ Quill embed blots (idempotent). Call before creating a Quill instance. */
export function registerChatQuillBlots(): void {
  if (chatQuillBlotsRegistered) {
    return;
  }
  registerCrmActionBlot();
  chatQuillBlotsRegistered = true;
}
